import { Component, OnInit } from "@angular/core";
import { LstorageService } from "src/app/services/lstorage.service";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { DaoService } from "src/app/services/dao.service";
import * as jwtDecode from "jwt-decode";
import { SpinnerService } from "src/app/shared/spinner/spinner.service";
import { SpinnerComponent } from "src/app/shared/spinner/spinner.component";
import { ToastService } from "src/app/services/toast.service";
import { MatDialogRef } from "@angular/material/dialog";
import { decryptData, encryptData } from "src/app/services/aes.service";
// import { BlobServiceClient } from "@azure/storage-blob";
interface subCatModel {
  categoryId?: string;
  subCategoryId?: string;
  Name: string;
  isActive: boolean;
  createdBy?: string;
  createdOn: string;
  modifiedBy?: string;
  modifiedOn?: string;
}
@Component({
  selector: "app-subcategoryform",
  templateUrl: "./subcategoryform.component.html",
  styleUrls: ["./subcategoryform.component.scss"],
})
export class SubcategoryformComponent implements OnInit {
  subcategoryList: any;
  dataSource: any;
  paginator: any;
  logoPreview: any;
  public validator = {
    errorMessage: "",
    UniqueSubcategory: false,
  };

  Subcategory = new FormGroup({
    subcategoryId: new FormControl(),
    categoryId: new FormControl(),
    name: new FormControl(),
    description: new FormControl(),
    isActive: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });
  modified_By: any;
  subcategoryid: any;
  created_By: any;
  subcategory: any;
  logo: File;
  aid: any;

  constructor(
    private daoService: DaoService,
    private fb: FormBuilder,
    private token: LstorageService,
    private toast: ToastService,
    public dialogRef: MatDialogRef<SubcategoryformComponent>,
    private spinner: SpinnerService
  ) {
    this.daoService.getSubcategoryList().subscribe((data: any) => {
      this.subcategoryList = data;
    });
  }

  ngOnInit() {
    this.created_By = jwtDecode(this.token.getToken());
    this.Subcategory = this.fb.group({
      subcategoryId: [""],
      categoryId: [""],
      name: ["", [Validators.required]],
      description: [""],
      isActive: [true],
      createdBy: [this.daoService.loggedUser.UserUniqueId],
      createdOn: ["2020-01-18T18:20:07.433Z"],
      modifiedBy: [this.daoService.loggedUser.UserUniqueId],
      modifiedOn: ["2020-01-18T18:20:07.433Z"],
    });
  }

  createsubcategory() {
    this.logoPreview = "";
    this.validator.UniqueSubcategory = false;
    this.Subcategory.value.name = this.Subcategory.value.name.trim();
    this.daoService.finalSelectedcatgeoryName.subscribe(
      (categoryName) => (this.Subcategory.value.categoryId = categoryName)
    );
    this.daoService.AddSubcategory(this.Subcategory.value).subscribe(
      (data: any) => {
        console.log("SubCatData", data);
        if (data.isSuccess) {
          this.daoService.dynamicSubCategoryList(data.data);
        }
        if (data.isSuccess) {
          this.toast.openSnackBar("Category added successfully", "close");
        }
        this.dialogRef.close();
      },
      (error) => {
        console.log(error);
        this.validator.UniqueSubcategory = true;
        this.validator.errorMessage = error.error.userMessage;
      }
    );
  }

  onfileselected(event) {
    this.logo = <File>event.target.files[0];
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event) => {
        this.logoPreview = reader.result;
      };
    }
  }

  // onFileSelected(event) {
  //   this.logo = <File>event.target.files[0];
  //   console.log("event.target.files", event.target.files);
  //   console.log("this.logo", this.logo);

  //   if (event.target.files && event.target.files[0]) {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(event.target.files[0]);
  //     reader.onload = () => {
  //       this.logoPreview = reader.result; // For preview purposes
  //     };

  // Prepare for Azure Blob upload
  // const blobServiceClient = new BlobServiceClient(`https://<your-storage-account-name>.blob.core.windows.net/?<your-sas-token>`);

  // const AZURE_STORAGE_CONNECTION_STRING =
  //   "BlobEndpoint=https://blobkeygenlist.blob.core.windows.net/;QueueEndpoint=https://blobkeygenlist.queue.core.windows.net/;FileEndpoint=https://blobkeygenlist.file.core.windows.net/;TableEndpoint=https://blobkeygenlist.table.core.windows.net/;SharedAccessSignature=sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2025-07-11T15:42:43Z&st=2024-07-11T07:42:43Z&spr=https,http&sig=o5RdCoonezX%2BwZox7L6J%2F%2FmR0Y%2BTrzJMvHmXi3G6coo%3D";

  // const blobServiceClient = new BlobServiceClient(
  //   AZURE_STORAGE_CONNECTION_STRING
  // );
  // const containerClient = blobServiceClient.getContainerClient(
  //   "your-container-name"
  // );

  // // Create the folder (directory) name from the image file name
  // const folderName = this.logo.name.split(".")[0];
  // const blobName = `${folderName}/${this.logo.name}`;

  // const blockBlobClient = containerClient.getBlockBlobClient(blobName);

  // try {
  //   // Upload the file to Azure Blob Storage
  //   const uploadBlobResponse = blockBlobClient.uploadBrowserData(this.logo);
  //   console.log("Blob uploaded successfully:", uploadBlobResponse);
  // } catch (error) {
  //   console.error("Error uploading blob:", error);
  // }
  //   }
  // }

  createtemplate() {
    this.logoPreview = "";
    this.spinner.show();
    this.validator.UniqueSubcategory = false;
    //for categoryName
    this.validator.UniqueSubcategory = false;
    this.daoService.finalSelectedcatgeoryName.subscribe(
      (categoryName) => (this.Subcategory.value.categoryId = categoryName)
    );
    //For File
    const fd = new FormData();
    if (this.logo) {
      fd.append("logo", this.logo, this.logo.name);
    }
    const subCategoryData: subCatModel = {
      categoryId: this.Subcategory.value.categoryId,
      subCategoryId: this.Subcategory.value.subcategoryId,
      Name: this.Subcategory.value.name,
      isActive: true,
      createdOn: this.Subcategory.value.createdOn,
      modifiedOn: this.Subcategory.value.modifiedOn,
      createdBy: this.Subcategory.value.createdBy,
      modifiedBy: this.Subcategory.value.modifiedBy,
    };
    console.log("subCategoryData", subCategoryData);
    //For subCategory
    this.daoService.uploadSubCategoryLogo(subCategoryData).subscribe(
      (data: any) => {
        //if(data.IsSuccess){

        console.log("uploadSubCategoryLogoData", data);
        let userDetails = JSON.parse(decryptData(data.key));
        console.log("uploadSubCategoryLogoData1", userDetails);
        var data1 = {
          catId: data.categoryId,
        };
        this.daoService
          .getSubCategoryByCatId(encryptData(JSON.stringify(data1)))
          .subscribe((data: any) => {
            let data2 = JSON.parse(decryptData(data.key));
            this.daoService.defaultSubCategoryList(data2);
            this.logoPreview = "";
            this.spinner.hide();
            this.toast.openSnackBar("Subcategory added successfully", "close");
            this.dialogRef.close();
          });
        // }
      },
      (error) => {
        this.spinner.hide();
        console.log(error);
        this.validator.UniqueSubcategory = true;
        this.validator.errorMessage = error.error.userMessage;
      }
    );
  }

  closesubcategoryForm() {
    this.dialogRef.close();
  }

  handleInput(event) {
    if (event.which === 32 && !this.Subcategory.value.name.length)
      event.preventDefault();
  }
}
